import { render, staticRenderFns } from "./AccountProfile.vue?vue&type=template&id=3bf42ac8&scoped=true&"
import script from "./AccountProfile.vue?vue&type=script&lang=js&"
export * from "./AccountProfile.vue?vue&type=script&lang=js&"
import style0 from "./AccountProfile.vue?vue&type=style&index=0&id=3bf42ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf42ac8",
  null
  
)

export default component.exports